import { Button, ButtonProps, Typography } from "@mui/material"
import { NavLink } from "react-router-dom"
import Iconify from "../../../components/iconify"
import { PATH_APP, PATH_USER } from "../../../routes/paths"

interface PortalNotificationActionAreaI extends ButtonProps {
    to?: string,
    text?: string,
}

export default function PortalNotificationActionArea({ text, to, sx, ...props }: PortalNotificationActionAreaI) {

    if (!to || !text) {
        return null
    }

    const isExternal = !to.startsWith('/')

    return (
        <>
            <NavButton
                sx={sx}
                text={text}
                to={to}
                {...props}
                navToExternalSite={isExternal}
            />
        </>
    )
}


function NavButton({
    to,
    text,
    variant = 'contained',
    sx,
    size,
    navToExternalSite = false
}
    : PortalNotificationActionAreaI & { navToExternalSite?: boolean }) {

    if (!to || !text) {
        return null
    }

    // For external URLs, use regular anchor tag; for internal, use NavLink
    if (navToExternalSite) {
        // If URL doesn't have a protocol, prepend https:// so browser treats it as absolute
        const href = to.startsWith('http://') || to.startsWith('https://') ? to : `https://${to}`
        return <Button
            onClick={(e) => { e.stopPropagation() }}
            sx={sx}
            size={size}
            variant={variant}
            component="a"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<Iconify icon='eva:external-link-outline' />}
        >
            <Typography fontSize={size} whiteSpace='nowrap' textOverflow='ellipsis' overflow='hidden'>
                {text}
            </Typography>
        </Button>
    }

    return <Button
        onClick={(e) => { e.stopPropagation() }}
        sx={sx}
        size={size}
        variant={variant}
        component={NavLink}
        to={to}
        target="_self"
        startIcon={<Iconify icon='eva:arrow-forward-outline' />}
    >
        <Typography fontSize={size} whiteSpace='nowrap' textOverflow='ellipsis' overflow='hidden'>
            {text}
        </Typography>
    </Button>
}

